import { CheckboxProps } from 'antd/lib/checkbox';
import { StyledCheckbox } from './styled';

export const Checkbox: React.FC<CheckboxProps> = ({ children, ...props }) => (
    <StyledCheckbox {...props}>{children}</StyledCheckbox>
);
